
import React, { Component } from 'react';


const RoutemapTransitAction = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        //console.log("Props ", props);
        props.onShowTransitRouteMap(props?.data);
    };

    return (
        <div>
			<button onClick={handleClick} className="custom-btn label label-success"><i className="icofont icofont-map-pins f20"></i> </button>
       
        </div>
    );
};

export default RoutemapTransitAction;
